import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createGroup({ commit }, data) {
      try {
        return await api.post(`/params/groups`, data)
      } catch (error) {
        throw error
      }
    },

    async getGroups({ commit }) {
      try {
        const response = await api.get(`/params/groups`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getGroupsActives({ commit }) {
      try {
        const response = await api.get(`/params/groups?status=true`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getGroup({ commit }, id) {
      try {
        const response = await api.get(`/params/groups/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateGroup({ commit }, data) {
      try {
        return await api.put(`/params/groups/${data.id}`, data.group)
      } catch (error) {
        throw error
      }
    },

    async deleteGroup({ commit }, id) {
      try {
        return await api.delete(`/params/groups/${id}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
